import React, { useEffect, useContext, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Confetti from 'react-confetti';
import { AppContext } from '../../context/AppContext';
import { insertQuestion1, insertQuestion2, insertQuestion3 } from '../../db/indexedDb.js';
import { TIMEOUT, BANNER_STAY_TIME } from '../../config/index.js';

import pharmacistImage from '../../images/question3Image.jpeg';

import './question3.css';
const checkIcon = require('../../images/check.png');

// Import images as URLs
const footerBanner1 = require('../../images/banner1.jpeg');
const footerBanner2 = require('../../images/banner2.jpeg');

const Question3 = () => {
  const { response } = useContext(AppContext);
 
  const resetTime = TIMEOUT;
  const [showConfetti, setShowConfetti] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);
   
  const banners = [footerBanner1, footerBanner2];

  const bannerTimerRef = useRef(null);
  const timerRef = useRef(null);

  const navigate = useNavigate();

  function getCurrentDateTimeUTC() {
    const now = new Date();
    const year = now.getUTCFullYear();
    const month = String(now.getUTCMonth() + 1).padStart(2, '0');
    const day = String(now.getUTCDate()).padStart(2, '0');
    const hours = String(now.getUTCHours()).padStart(2, '0');
    const minutes = String(now.getUTCMinutes()).padStart(2, '0');
    const seconds = String(now.getUTCSeconds()).padStart(2, '0');
    const dateTimeUTC = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return dateTimeUTC;
  }

  const submitFinalResponse = async (answerQ3) => {
    const insertResponse1 = async () => {
      await insertQuestion1(response.question1.device_id, response.question1.response_value, response.question1.datetime_, {}, response.customer_feedback_id);
    };
    try {
      await insertResponse1();
    } catch (error) {
      console.error('Error inserting response 1:', error);
    }

    const insertResponse2 = async () => {
      console.log('calling insertResponse2');
      await insertQuestion2(response.question2.device_id, response.question2.response_value, response.question2.datetime_, response.customer_feedback_id);
    }
    try {
      await insertResponse2();
    } catch (error) {
      console.error('Error inserting response 2:', error);
    }

    const insertResponse3 = async () => {
      await insertQuestion3(response.question3.device_id, answerQ3, getCurrentDateTimeUTC(), response.customer_feedback_id);
    }
    try {
      await insertResponse3();
    } catch (error) {
      console.error('Error inserting response 3:', error);
    }
  }

  const handleSubmitQUestion = (e, answerQ3) => {
    e.preventDefault();
    submitFinalResponse(answerQ3);

    setShowConfetti(true);
    setShowSuccessMessage(true);

    setTimeout(() => {
      setShowConfetti(false);
      setShowSuccessMessage(false);
      navigate('/');
    }, 5000);
  }

  const handleBack = () => {
    navigate(-1); // Go back to the previous page
  }

  useEffect(() => {
    const lockOrientation = async () => {
      // There is no direct equivalent for locking orientation in web
    };
    lockOrientation();
  }, []);

  useEffect(() => {
    startTimer();
    return () => {
      clearTimer();
    };
  }, []);

  const startTimer = () => {
    clearTimer();
    timerRef.current = setTimeout(() => {
      const insertResponse1 = async () => {
        await insertQuestion1(response.question1.device_id, response.question1.response_value, response.question1.datetime_, {}, response.customer_feedback_id);
      }
      insertResponse1();

      const insertResponse2 = async () => {
        await insertQuestion2(response.question2.device_id, response.question2.response_value, response.question2.datetime_, response.customer_feedback_id);
      }
      insertResponse2();

      navigate('/');
    }, resetTime);
  };

  const clearTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  };

  const resetTimer = () => {
    startTimer();
  };

   // footer banner rotation logic
   useEffect(() => {
    startBannerRotation();
    return () => {
      clearInterval(bannerTimerRef.current);
    };
  }, []);

  const startBannerRotation = () => {
    bannerTimerRef.current = setInterval(() => {
      setCurrentBannerIndex((prevIndex) => (prevIndex + 1) % banners.length);
    }, BANNER_STAY_TIME); // Change banner every 10 seconds
  };

  return (
    <div className="question3-container" onClick={resetTimer}>
      <div className="question3-subContainer">
        <div className="question3-textContainer">
          <div className="question3-text">Are you aware we have MX Vitamin D Deficiency Rapid Home Test available in store?</div>
          <div className='question3-image-container'>
            <img className="question3-image" src={pharmacistImage} alt="Pharmacist" />
          </div>
         
        </div>
        
        <div className="question3-buttonContainer">
          <button className="question3-button" onClick={(e) => handleSubmitQUestion(e, 'no')}>
            <div className="question3-no-text-container">
              <span className="question3-no-text">No &#10007;</span>
            </div>
            </button>
          <button className="question3-button" onClick={(e) => handleSubmitQUestion(e, 'yes')}>
            <div className="question3-yes-text-container">
              <span className="question3-yes-text">Yes &#10004;</span> 
            </div>
          </button>
        </div>

       
      </div>

      <div className='question3-footer-banner-container'>
          <img className='question3-footer-banner-img' src={banners[currentBannerIndex]} alt='Banner' />
        </div>
     

      {showConfetti && <Confetti numberOfPieces={400} />}

      {showSuccessMessage && (
        <div className="question3-successMessageContainer">
          <img className="question3-checkIcon" src={checkIcon} alt="Check icon" />
          <div className="question3-successMessageText">Thank you for your response!</div>
        </div>
      )}
    </div>
  );
};

export default Question3;
